import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Copy, CheckCircle2 } from "lucide-react";
import { useState } from "react";

export default function EditLinkDialog({ link, onClose }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Enlace copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar. Por favor selecciónelo manualmente.");
    }
  };

  return (
    <Dialog open={!!link} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="edit-link-dialog"
        className="max-w-lg bg-white border-2 border-[#D1C9C1]"
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full bg-[#2C5545]/10 flex items-center justify-center">
              <CheckCircle2 className="w-7 h-7 text-[#2C5545]" />
            </div>
            <DialogTitle className="font-serif text-2xl text-[#1A1818]">
              ¡Necesidad Publicada!
            </DialogTitle>
          </div>
          <DialogDescription className="text-base text-[#4A4646] pt-3">
            <strong>Guarde este enlace privado.</strong> Es la única forma de editar, marcar como completada o eliminar su publicación. No se puede recuperar después.
          </DialogDescription>
        </DialogHeader>

        <div className="bg-[#FEF3C7] border-2 border-[#D97706]/30 rounded-lg p-4 my-2">
          <p className="text-sm font-semibold text-[#92400E] mb-2">Su enlace de edición privado:</p>
          <div className="flex gap-2">
            <Input
              data-testid="edit-link-input"
              value={link || ""}
              readOnly
              className="text-sm border-2 border-[#D1C9C1] bg-white font-mono"
              onFocus={(e) => e.target.select()}
            />
            <Button
              data-testid="copy-edit-link"
              onClick={copy}
              className="bg-[#8A3A33] hover:bg-[#6B2B25] text-white shrink-0"
            >
              <Copy className="w-4 h-4 mr-2" />
              {copied ? "Copiado" : "Copiar"}
            </Button>
          </div>
        </div>

        <DialogFooter>
          <Button
            onClick={onClose}
            data-testid="edit-link-close"
            className="w-full h-12 text-base bg-[#2C5545] hover:bg-[#1F3D32] text-white"
          >
            He guardado el enlace
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
